var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 198,
    viewBox: "0 0 180 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.913 121.18C114.481 121.31 114.062 121.458 113.654 121.626C113.435 121.715 113.199 121.756 112.963 121.749C112.727 121.741 112.495 121.683 112.282 121.58C112.07 121.477 111.881 121.331 111.728 121.15C111.575 120.97 111.462 120.76 111.396 120.533L104.656 97.8867L27.8916 120.732L46.1928 182.231C46.8335 184.38 48.3016 186.188 50.2744 187.255C52.2472 188.322 54.5632 188.562 56.713 187.922L117.268 169.899C119.418 169.258 121.225 167.79 122.292 165.817C123.36 163.844 123.6 161.528 122.96 159.379L118.634 144.839C118.566 144.612 118.545 144.374 118.575 144.14C118.604 143.905 118.682 143.679 118.804 143.477C118.925 143.274 119.088 143.099 119.282 142.963C119.475 142.827 119.695 142.733 119.927 142.688C120.364 142.606 120.797 142.502 121.224 142.375C127.58 140.477 131.317 134.205 129.576 128.349C127.836 122.494 121.269 119.29 114.913 121.18Z",
    fill: "#4C9B58"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.381 178.938C94.381 178.938 60.7952 188.365 53.3983 182.892C47.1659 178.291 46.8789 173.548 38.0331 154.834C37.9335 170.96 46.7343 197.427 46.7343 197.427L94.381 178.938Z",
    fill: "#4C9B58"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5039 115.26C56.5039 115.26 59.7814 130.95 71.6605 127.416C83.5395 123.883 77.6937 108.949 77.6937 108.949L56.5039 115.26Z",
    fill: "#4C9B58"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9429 28.2852L15.2795 48.7137C13.1301 49.3538 11.3229 50.8214 10.2556 52.7939C9.18817 54.7663 8.94798 57.0819 9.5878 59.2315L27.8914 120.73L54.2345 112.904C54.4425 112.842 54.6614 112.823 54.877 112.85C55.0926 112.876 55.3003 112.948 55.4867 113.06C55.6731 113.171 55.8342 113.32 55.9595 113.498C56.0849 113.675 56.1718 113.877 56.2148 114.09C56.2922 114.485 56.3903 114.881 56.5088 115.276C58.4061 121.629 64.6788 125.369 70.5318 123.626C76.3848 121.883 79.6006 115.326 77.7081 108.965C77.5895 108.571 77.4567 108.185 77.3049 107.81C77.2257 107.609 77.1893 107.393 77.1981 107.176C77.2068 106.96 77.2606 106.748 77.3558 106.553C77.4511 106.359 77.5858 106.186 77.7513 106.046C77.9169 105.907 78.1097 105.803 78.3176 105.742L104.661 97.9019L83.9429 28.2852Z",
    fill: "#F5F5F1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.52
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1404 95.8106C19.1404 95.8106 9.72295 62.2248 15.1846 54.8279C19.7878 48.5955 27.934 44.948 37.5554 42.0832C21.4289 41.9836 0.649414 48.1639 0.649414 48.1639L19.1404 95.8106Z",
    fill: "#F5F5F1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.943 28.2864L89.841 48.103C89.9365 48.4186 89.9634 48.7511 89.9197 49.0779C89.8761 49.4048 89.7629 49.7185 89.5879 49.998C89.4129 50.2775 89.18 50.5163 88.905 50.6983C88.63 50.8803 88.3193 51.0013 87.9936 51.0532C87.3785 51.1447 86.7707 51.2795 86.1746 51.4564C79.8212 53.3536 76.0813 59.6264 77.8244 65.4817C79.5675 71.337 86.1248 74.5481 92.4829 72.658C93.0794 72.4814 93.662 72.261 94.226 71.9987C94.5268 71.8663 94.8523 71.7995 95.181 71.8027C95.5096 71.8058 95.8338 71.879 96.1319 72.0172C96.4301 72.1554 96.6954 72.3555 96.9102 72.6042C97.125 72.8529 97.2844 73.1445 97.3778 73.4596L104.647 97.8865L129.721 90.4209C130.44 90.2016 131.042 89.7071 131.398 89.0451C131.753 88.3831 131.832 87.6074 131.618 86.8873L131.597 86.8161C129.7 80.4604 132.92 73.896 138.773 72.1552C144.626 70.4145 150.906 74.1521 152.796 80.5078L152.817 80.5766C153.033 81.2987 153.526 81.906 154.188 82.2653C154.85 82.6245 155.628 82.7063 156.351 82.4928L173.308 77.4462C175.457 76.806 177.264 75.3384 178.332 73.3659C179.399 71.3935 179.639 69.0779 178.999 66.9283L163.11 13.5354C162.47 11.3859 161.002 9.57879 159.03 8.51141C157.057 7.44403 154.742 7.20384 152.592 7.84366L83.943 28.2864Z",
    fill: "#3C3C3C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1745 51.4528C86.1745 51.4528 79.5911 54.9342 81.9911 63.0117C84.3911 71.0892 90.0046 72.1398 93.6971 72.7991C87.0567 78.5809 67.4346 70.622 67.4346 70.622L74.848 50.6797L86.1745 51.4528Z",
    fill: "#D2E6D5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.152 50.5783C174.152 50.5783 163.672 17.3078 155.056 14.0991C147.794 11.398 137.4 10.4043 127.783 13.2667C141.237 4.36158 163.594 0.574219 163.594 0.574219L174.152 50.5783Z",
    fill: "#F5F5F1"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.703 134.711L155.751 142.039",
    stroke: "#1E1E1E",
    strokeWidth: 4.89592,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.305 109.578L167.891 106.037",
    stroke: "#1E1E1E",
    strokeWidth: 4.89592,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M159.832 123.137L169.615 126.353",
    stroke: "#1E1E1E",
    strokeWidth: 4.89592,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.af09487b4a3c394bfeee8a46a8ff1409.svg";
export { ForwardRef as ReactComponent };